import { getCategories, getCategoryPrices, createStream, purchasePackage, getStreams } from './agent';

import type {
    LeadCategory,
    LeadPackagePrice,
    CreateStreamRequest,
    Stream,
    PurchaseRequest,
    PurchaseResponse,
    StreamsResponse,
} from './agent';

class LeadStreamsService {
    queryKey = 'lead-streams';

    getCategories = async (): Promise<LeadCategory[]> => {
        try {
            const { data } = await getCategories();
            // Обрабатываем случай, когда API возвращает объект с results (пагинация)
            if (data && typeof data === 'object' && 'results' in data && Array.isArray((data as any).results)) {
                return Promise.resolve((data as any).results);
            }
            // Или просто массив
            if (Array.isArray(data)) {
                return Promise.resolve(data);
            }
            return Promise.resolve([]);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getCategoryPrices = async (categoryId: number): Promise<LeadPackagePrice[]> => {
        try {
            const { data } = await getCategoryPrices(categoryId);
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getStreams = async (): Promise<Stream[]> => {
        try {
            const { data } = await getStreams();
            // Обрабатываем случай, когда API возвращает объект с results (пагинация)
            if (
                data &&
                typeof data === 'object' &&
                'results' in data &&
                Array.isArray((data as StreamsResponse).results)
            ) {
                return Promise.resolve((data as StreamsResponse).results);
            }
            // Или просто массив
            if (Array.isArray(data)) {
                return Promise.resolve(data);
            }
            return Promise.resolve([]);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    createStream = async (data: CreateStreamRequest): Promise<Stream> => {
        try {
            const { data: response } = await createStream(data);
            return Promise.resolve(response);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    purchasePackage = async (streamId: number, data: PurchaseRequest): Promise<PurchaseResponse> => {
        try {
            const { data: response } = await purchasePackage(streamId, data);
            return Promise.resolve(response);
        } catch (error) {
            return Promise.reject(error);
        }
    };
}

export default new LeadStreamsService();
